import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor() {}

  private ACCESS_KEY = 'audit_log_access_token';
  private REFRESH_KEY = 'audit_log_refresh_token';

  isLoggedIn(): boolean {
    return this.getToken() != '';
  }
  
  async logout(): Promise<void> {
    document.cookie = `${this.ACCESS_KEY}=;domain=.` + environment.cookiesDomain + `;path=/;`;
    await this.clearIndexedDB();

  }



  // Use sessionStorage (not localStorage)
  getToken(): string | null {
    return (
      document.cookie
        .match('(^|;)\\s*' + this.ACCESS_KEY + '\\s*=\\s*([^;]+)')
        ?.pop() || ''
    );
  }

  getRefreshToken(): string | null {
    return (
      document.cookie
        .match('(^|;)\\s*' + this.REFRESH_KEY + '\\s*=\\s*([^;]+)')
        ?.pop() || ''
    );
  }

  setToken(accessToken: string, refreshToken?: string) {
    if (accessToken) {
      document.cookie = `${this.ACCESS_KEY}=${accessToken};domain=.` +
      environment.cookiesDomain +
      ';path=/';
    }
    if (refreshToken) {
      document.cookie = `${this.REFRESH_KEY}=${refreshToken};domain=.` +
      environment.cookiesDomain +
      ';path=/';
      // document.cookie = `refresh_token=${refreshToken};domain=.yourdomain.com;path=/`;
    }
  }

 loggedOut() {
   this.clearIndexedDB();
  localStorage.clear();
  sessionStorage.clear();

  const cookiesToClear = [this.ACCESS_KEY, this.REFRESH_KEY];
  cookiesToClear.forEach(name => {
    document.cookie = `${name}=; path=/; domain=.${environment.cookiesDomain}; Max-Age=0`;
  });

  window.location.href = '/login';
}


  setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

    // 🔹 Clear all IndexedDB databases
  private async clearIndexedDB(): Promise<void> {
    const databases = await (window.indexedDB as any).databases();
    for (const db of databases) {
      if (db.name) {
        indexedDB.deleteDatabase(db.name);
      }
    }
  }
}
